import { render, staticRenderFns } from "./model_6.vue?vue&type=template&id=0f74b526&scoped=true"
import script from "./model_6.vue?vue&type=script&lang=js"
export * from "./model_6.vue?vue&type=script&lang=js"
import style0 from "./model_6.vue?vue&type=style&index=0&id=0f74b526&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f74b526",
  null
  
)

export default component.exports